import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';

export const StyledSlotSelector = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  margin: 0 ${rem(16)} 0 ${rem(16)};
`;

export const StyledLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(12)};
  padding: ${rem(30)} 0;
`;

export const StyledSlotFooter = styled.div`
  padding: ${rem(16)} 0 ${rem(16)} 0;
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 ${rem(20)} ${rem(20)} ${rem(20)};
  padding: ${rem(12)};
  background-color: ${variables.colors.highlightBg};
`;
